import { withUppercaseFirstLetter } from '@/common/utils/withUppercaseFirstLetter';

import type { FunctionalGridElementTypes } from '../../grid/FunctionalGrid';

export function parseGridElementType(str: string): FunctionalGridElementTypes {
  if (str.toLocaleLowerCase().includes('switches')) return 'Switch';
  if (str.endsWith('s')) {
    str = str.slice(0, -1);
  }
  const parsedGridElementType = withUppercaseFirstLetter(str);

  return parsedGridElementType as unknown as FunctionalGridElementTypes;
}
